// extracted by mini-css-extract-plugin
export var link = "contact-link-module--link--81cba";
export var linkDecorative = "contact-link-module--linkDecorative--19820";